import LoadableComponent from './../Loadable/index';

export const publicRouter: any = [
  {
    path: '/',
    exact: true,
    name: 'public',
    title: 'Pser',
    component: LoadableComponent(() => import('../Layout/PublicLayout')),
    isLayout: true,
    showInMenu: false,
    index: 0
  },
  {
    path: '/login',
    name: 'login',
    title: 'LogIn',
    component: LoadableComponent(() => import('../../scenes/Login')),
    showInMenu: false,
    index: 0
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    title: 'ForgotPassword',
    component: LoadableComponent(() => import('../../scenes/Forgot Password')),
    showInMenu: false,
    index: 1
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    title: 'ResetPassword',
    component: LoadableComponent(() => import('../../scenes/Password Reset')),
    showInMenu: false,
    index: 1
  }
];

export const appRouters: any = [
  //#region none display
  {
    path: '/user',
    exact: true,
    name: 'home',
    permission: '',
    title: 'Home',
    icon: 'home',
    component: LoadableComponent(() => import('../../components/Layout/AppLayout')),
    isLayout: true,
    showInMenu: false,
    index: 0
  },
  {
    path: '/user/logout',
    permission: '',
    title: 'Logout',
    name: 'logout',
    icon: 'info-circle',
    showInMenu: false,
    component: LoadableComponent(() => import('../../components/Logout')),
    index: 0
  },
  {
    path: '/exception',
    permission: '',
    title: 'exception',
    name: 'exception',
    icon: 'info-circle',
    showInMenu: false,
    component: LoadableComponent(() => import('../../scenes/Exception'))
  },
  {
    path: '/user/cart-item',
    permission: '',
    title: 'CartItem',
    name: 'CartItem',
    showInMenu: false,
    component: LoadableComponent(() => import('../../scenes/CartItem'))
  },
  {
    path: '/user/order-tracking',
    permission: '',
    title: 'OrderTracking',
    name: 'OrderTracking',
    showInMenu: false,
    component: LoadableComponent(() => import('../../scenes/OrderTracking'))
  },
  //#endregion
  {
    type: 'menu',
    path: '/user/dashboard',
    name: 'dashboard',
    permission: '',
    title: 'Dashboard',
    icon: 'home',
    showInMenu: true,
    component: LoadableComponent(() => import('../../scenes/Dashboard')),
    index: 1
  },
  {
    type: 'menu',
    path: '/user/new-quote',
    name: 'new-quote',
    permission: '',
    title: 'NewQuote',
    icon: 'diff',
    showInMenu: true,
    component: LoadableComponent(() => import('../../scenes/NewQuote')),
    index: 2
  },
  {
    type: 'menu',
    path: '/user/inventory',
    name: 'inventory',
    permission: '',
    title: 'Inventory',
    icon: 'database',
    showInMenu: true,
    component: LoadableComponent(() => import('../../scenes/Inventory')),
    index: 3
  },
  {
    type: 'menu',
    path: '/user/help',
    name: 'help',
    permission: '',
    title: 'Help',
    icon: 'question-circle',
    showInMenu: true,
    component: LoadableComponent(() => import('../../scenes/Help')),
    index: 99
  },
  {
    type: 'menu',
    path: '/user/password',
    name: 'password',
    permission: '',
    title: 'Password',
    icon: 'question-circle',
    showInMenu: true,
    component: LoadableComponent(() => import('../../scenes/Password')),
    index: 99
  },
  {
    type: 'menu',
    path: '/user/profile',
    name: 'profile',
    permission: '',
    title: 'Profile',
    icon: 'user',
    showInMenu: true,
    component: LoadableComponent(() => import('../../scenes/Profile')),
    index: 99
  },
  {
    type: 'menu',
    path: '/user/overview',
    name: 'overview',
    permission: '',
    title: 'Overview',
    icon: 'question-circle',
    showInMenu: true,
    component: LoadableComponent(() => import('../../scenes/Overview')),
    index: 99
  },
  //#endregion
];

export const adminRouter = [
  {
    path: '/admin',
    name: 'admin',
    title: 'Admin',
    component: LoadableComponent(() => import('../../components/Layout/AdminLayout')),
    showInMenu: false,
    index: 0,
  },
];

export const routers = [...publicRouter, ...appRouters, ...adminRouter];
